"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRule = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRule extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.ruleId = obj.ruleId;
            this.ruleName = obj.ruleName;
            this.ruleVersionId = obj.ruleVersionId;
            this.dataFilterClauses = obj.dataFilterClauses;
        }
    }
}
exports.MarketRule = MarketRule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlEQUFvRDtBQUVwRCxNQUFhLFVBQVcsU0FBUSxpQ0FBYztJQU0xQzs7O09BR0c7SUFDSCxZQUFtQixHQUF5QjtRQUN4QyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFFWCxJQUFJLEdBQUcsRUFBRSxDQUFDO1lBQ04sSUFBSSxDQUFDLE1BQU0sR0FBRyxHQUFHLENBQUMsTUFBTyxDQUFDO1lBQzFCLElBQUksQ0FBQyxRQUFRLEdBQUcsR0FBRyxDQUFDLFFBQVMsQ0FBQztZQUM5QixJQUFJLENBQUMsYUFBYSxHQUFHLEdBQUcsQ0FBQyxhQUFjLENBQUM7WUFDeEMsSUFBSSxDQUFDLGlCQUFpQixHQUFHLEdBQUcsQ0FBQyxpQkFBa0IsQ0FBQztRQUNwRCxDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBcEJELGdDQW9CQyJ9